import WPCI from '../../static/WPCI.json';

export const ABI = WPCI.abi;



// testnet
// export const etherScanUrl = "https://sepolia.etherscan.io";
// export const tokenAddress = "0xa1f5612B00A4Ce54d512C4B28801B3fC5A78D4A6";


// mainnet

export const etherScanUrl = "https://etherscan.io";
export const tokenAddress = "0x3C2A309d9005433c1BC2C92EF1bE06489e5bf258";




// WEBPACK FOOTER //
// ./src/js/wpci.js